<template>
  <!-- AAC——辅助沟通技术 -->
  <div class="AAC">
    <PublicCert :logo="Logo5" :type="'aac'" :color="'#36b9bf'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo5 from '@/assets/images/logo5.png'

export default {
  name: 'AAC',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo5
    }
  }
}
</script>
